export const BRASPAG_ORG_ID = '1snn5n9w';
export const BRASPAG_PROVIDER_MERCHANT_ID = 'BRASPAG_ENDURANCE';
export const IFRAME_URL_FINGERPRINT = 'https://h.online-metrix.net';
